var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-progress-circular',{staticClass:"mx-1",attrs:{"size":"20","width":"3","indeterminate":""}})}
var staticRenderFns = []

export { render, staticRenderFns }